<p class="mb-4">{{ 'popins.logout.text' | translate }}</p>
<ng-casto-btn
  class="light-grey mr-3"
  (click)="modal.close()"
  [label]="'popins.logout.cancel' | translate"></ng-casto-btn>
<ng-casto-btn class="blue" (click)="signout()" [label]="'popins.logout.confirm' | translate"></ng-casto-btn>
